import React from 'react';
interface CategoryPillProps {
  category: 'utilities' | 'entertainment' | 'productivity' | 'design';
  children: React.ReactNode;
}
export function CategoryPill({
  category,
  children
}: CategoryPillProps) {
  const styles = {
    utilities: 'bg-[#3a3a2a] text-[#cccc88] border-[#4a4a3a]',
    entertainment: 'bg-[#3a2a4a] text-[#cc88ff] border-[#4a3a5a]',
    productivity: 'bg-[#2a3a4a] text-[#88ccff] border-[#3a4a5a]',
    design: 'bg-[#4a2a3a] text-[#ff88cc] border-[#5a3a4a]'
  };
  return <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium border ${styles[category]}`} data-id="element-6">
      {children}
    </span>;
}